module.exports = global["jQuery"] = require("-!/tmp/build_32c56a6c/node_modules/expose-loader/index.js?$!./jquery.js");